import Checkout from "@/views/Checkout.vue";
import FormSaved from "@/views/FormSaved.vue";
import FormSearch from "@/views/FormSearch.vue";
import FormWrapper from "@/views/FormWrapper.vue";
import FormWrapperTRC from "@/views/FormWrapperTRC.vue";
import Home from "@/views/Home.vue";
import NotFound from "@/views/NotFound.vue";
import Permits from "@/views/Permits.vue";
import Reporting from "@/views/Reporting.vue";
import ThankYou from "@/views/ThankYou.vue";
import ThankYouNoFee from "@/views/ThankYouNoFee.vue"
import TRCRenewal from "@/views/permits/RockCrushing/TRCRenewal.vue"

export default {
    Checkout,
    FormSaved,
    FormSearch,
    FormWrapper,
    FormWrapperTRC,
    Home,
    NotFound,
    Permits,
    Reporting,
    ThankYou,
    ThankYouNoFee,
    TRCRenewal
}